import {Injectable} from '@angular/core';
import {BaseHubService} from './base-hub.service';
import {HttpClient} from '@angular/common/http';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {BehaviorSubject} from 'rxjs';
import {IBaseObject} from '../../_models/BaseObject';

@Injectable({
  providedIn: 'root',
})
export class RefreshMapService extends BaseHubService<any> {
  public readonly refreshed$ = new BehaviorSubject<boolean>(false);

  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super(
      '',
      'hubs/modificationCarteHub',
      'Modification Carte',
      http,
      messageService,
      configService
    );
  }

  async refreshHubConnection(): Promise<void> {
    try {
      await this.start();
      this.connection.on(
        'actualisation',
        (modificationDetectee: boolean) =>
          this.refreshed$.next(modificationDetectee)
      );
    } catch (error) {
      console.error(error);
    }
  }

  protected dispatchDeleteData(ids: Array<string | number>): void {
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
  }
}
